import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import {
  HomeIcon,
  CameraIcon,
  PlusIcon,
  UserIcon,
  SearchIcon,
  SalesIcon,
} from "./Icons";

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { openCommandPalette } = useApp();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="bottom-nav">
      <button
        className={`nav-item ${isActive("/") ? "active" : ""}`}
        onClick={() => navigate("/")}
      >
        <div className="nav-item-icon">
          <HomeIcon size={20} />
        </div>
        <div>Home</div>
      </button>
      <button
        className={`nav-item ${isActive("/scan") ? "active" : ""}`}
        onClick={() => navigate("/scan")}
      >
        <div className="nav-item-icon">
          <CameraIcon size={20} />
        </div>
        <div>Scan</div>
      </button>
      <button className="nav-item" onClick={openCommandPalette}>
        <div className="nav-item-icon">
          <SearchIcon size={20} />
        </div>
        <div>Search</div>
      </button>
      <button
        className={`nav-item ${isActive("/create") ? "active" : ""}`}
        onClick={() => navigate("/create")}
      >
        <div className="nav-item-icon">
          <PlusIcon size={20} />
        </div>
        <div>Add</div>
      </button>
      <button
        className={`nav-item ${location.pathname.startsWith("/sales") ? "active" : ""}`}
        onClick={() => navigate("/sales/listed")}
      >
        <div className="nav-item-icon">
          <SalesIcon size={20} />
        </div>
        <div>Sales</div>
      </button>
      <button
        className={`nav-item ${isActive("/account") ? "active" : ""}`}
        onClick={() => navigate("/account")}
      >
        <div className="nav-item-icon">
          <UserIcon size={20} />
        </div>
        <div>Account</div>
      </button>
    </div>
  );
}

export default BottomNav;
